module.exports = __webpack_public_path__ + "static/media/lonaci-online.38ed2f35.png";